import { render } from "./YourDetailsPV1.vue?vue&type=template&id=fb44bd34&scoped=true"
import script from "./YourDetailsPV1.vue?vue&type=script&lang=js"
export * from "./YourDetailsPV1.vue?vue&type=script&lang=js"

import "./YourDetailsPV1.vue?vue&type=style&index=0&id=fb44bd34&lang=scss"
import "./YourDetailsPV1.vue?vue&type=style&index=1&id=fb44bd34&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb44bd34"]])

export default __exports__